// extracted by mini-css-extract-plugin
module.exports = {"rangeThumbSize":"1.125rem","rangeThumbSizeDesktop":"1.25rem"};